import React from 'react'

const BaseLayout = ({ children }: any):JSX.Element => (
  <>
    {children}
  </>
)

export default BaseLayout
